import styled from 'styled-components'
import { HEIGHT_HEADER_PAGE } from '../constants/sizes'

export const ContentHeader = styled.div`
    min-height: ${HEIGHT_HEADER_PAGE + 'px'};
`
